import { useCallback, useMemo, useState } from "react";
import BioComponent from "../bio/BioComponent";
import BooksComponent from "../books/BooksComponent";
import FooterComponent from "../footer/FooterComponent";
import HomeComponent from "../home/HomeComponent";
import NavComponent from "../nav/NavComponent";
import "./main.css";

const MainComponent = () => {
  const [view, setView] = useState("home");

  const viewChanged = useCallback((e: any) => {
    setView(e);
  }, []);

  const buildView = useMemo(() => {
    window.scrollTo(0, 0);
    switch (view) {
      case "bio":
        return <BioComponent />;
      case "books":
        return <BooksComponent />;
      case "home":
      default:
        return <HomeComponent />;
    }
  }, [view]);

  return (
    <div className="pageWrapper">
      <NavComponent viewChanged={viewChanged} />
      <main className="mainContent">{buildView}</main>
      <FooterComponent />
    </div>
  );
};

export default MainComponent;
